<template lang="pug">

    div.nuff

        .ui.top.attached.header Allgemeine Informationen:
        .ui.bottom.attached.segment        
            address-general-information-form(
                ref="generalInformationForm"
                v-bind:company-models='companyModels'
                v-bind:country-models='countryModels'
                v-model='model'
            )

        .ui.top.attached.header Zusätzliche Angaben:
        .ui.bottom.attached.segment
            address-additional-information-form(v-model='model' ref="additionalInformationForm")

        .ui.top.attached.header Adresstyp:
        .ui.bottom.attached.segment
            address-types-form(
                v-on:default-billing-address="updateDefaultBillingAddress"
                v-on:default-correspondence-address="updateDefaultCorrespondenceAddress"
                v-on:default-shipping-address="updateDefaultShippingAddress"
                v-bind:hide-billing-address-warning='isDefaultBillingAddressLocked'
                v-bind:hide-correspondence-address-warning='isDefaultCorrespondenceAddressLocked'
                v-bind:hide-shipping-address-warning='isDefaultShippingAddressLocked'
                v-bind:is-default-billing-address='defaultBillingAddress'
                v-bind:is-default-correspondence-address='defaultCorrespondenceAddress'
                v-bind:is-default-shipping-address='defaultShippingAddress'
                v-bind:lock-is-billing-address='isDefaultBillingAddressLocked'
                v-bind:lock-is-correspondence-address='isDefaultCorrespondenceAddressLocked'
                v-bind:lock-is-shipping-address='isDefaultShippingAddressLocked'
                v-bind:lock-is-default-billing-address='isDefaultBillingAddressLocked'
                v-bind:lock-is-default-correspondence-address='isDefaultCorrespondenceAddressLocked'
                v-bind:lock-is-default-shipping-address='isDefaultShippingAddressLocked'
                v-model='model' ref="typeForm"
            )

        .ui.top.attached.header Avis:
        .ui.bottom.attached.segment
            address-advice-form(v-model='model.advice' ref="adviceForm")

        //- Actions
        action-row.ui.bottom.secondary(v-on:cancel="cancel()")

</template>

<script>
    import * as R from 'ramda'
    import { create_default_addresses_patch } from "@/utils/company"
    import ActionRow from '@/components/form/ActionRow'
    import AddressAdditionalInformationForm from '@/components/addresses/form/AdditionalInformation.vue'
    import AddressAdviceForm from '@/components/addresses/form/Advice.vue'
    import AddressGeneralInformationForm from '@/components/addresses/form/GeneralInformation.vue'
    import AddressTypesForm from '@/components/addresses/form/Types.vue'
    import Error from '@/components/form/FieldError.vue'

    //noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols,ReservedWordAsName
    export default {
        name: 'addresses-update-form',

        components: {
            ActionRow, AddressAdditionalInformationForm, AddressAdviceForm,
            AddressGeneralInformationForm, AddressTypesForm, Error
        },

        computed: {

            companyModel() {
                const link = R.head(this.addressModel.companies || [])
                const companyId = link ? link.company : undefined
                return R.defaultTo({}, R.find(R.propEq('id', companyId), this.companyModels))
            },

            isDefaultBillingAddressLocked() {
                return this.companyModel.defaultBillingAddress === this.addressModel.id
            },

            isDefaultCorrespondenceAddressLocked() {
                return this.companyModel.defaultCorrespondenceAddress === this.addressModel.id
            },

            isDefaultShippingAddressLocked() {
                return this.companyModel.defaultShippingAddress === this.addressModel.id
            },

        },

        created() {
            this.defaultBillingAddress        = this.companyModel.defaultBillingAddress === this.addressModel.id
            this.defaultCorrespondenceAddress = this.companyModel.defaultCorrespondenceAddress === this.addressModel.id
            this.defaultShippingAddress       = this.companyModel.defaultShippingAddress === this.addressModel.id

            this.model = {
                ...this.addressModel
            }
        },

        data() {
            return {
                defaultBillingAddress: false,
                defaultCorrespondenceAddress: false,
                defaultShippingAddress: false,
                model: {}
            }
        },

        methods: {

            persist() {
                return Promise.all([

                    // Adresse speichern
                    this.$store.dispatch('addresses/update', { model: this.model }),

                    // Standardadressen speichern
                    this.persistDefaultAddresses(),

                ])
            },

            persistDefaultAddresses() {
                const link = R.head(this.addressModel.companies || [])
                const model = create_default_addresses_patch(
                    link ? link.company : undefined,
                    this.addressModel.id
                )(this.$data)

                return this.$store.dispatch('companies/patch', { model })
            },

            updateDefaultBillingAddress(v) {
                this.defaultBillingAddress = v
            },

            updateDefaultCorrespondenceAddress(v) {
                this.defaultCorrespondenceAddress = v
            },

            updateDefaultShippingAddress(v) {
                this.defaultShippingAddress= v
            },

            validate() {
                return Promise.all([
                    this.$validate(),
                    this.$refs.generalInformationForm.validate(),
                    this.$refs.additionalInformationForm.validate(),
                    this.$refs.typeForm.validate(),
                    this.$refs.adviceForm.validate()
                ]).then(R.all(R.equals(true)))
            }

        },

        props: {

            addressModel: {
                type: Object,
                required: true
            },

            companyModels: {
                type: Array,
                required: true
            },

            countryModels: {
                type: Array,
                required: true
            },

            stateModels: {
                type: Array,
                default: () => []
            }

        },

        validators: {},

    }

</script>
